import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createUserGroupToUserEntityInfo } from 'record-it-time-common/entity/entities/UserGroupToUser/createUserGroupToUserEntityInfo';
import { UserGroupToUser } from './userGroupToUserTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export const userGroupToUserEntityInfo =
  createUserGroupToUserEntityInfo<UserGroupToUser>({
    additionalFieldInfos:
      EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
  });
